<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="نرجسية"><div class="section level2" id="narcissistic" style="padding-top:130px">
<p><span dir="rtl">عندما تحتسي قهوة وبيدك كتاب، حينها لا حاجة إلى الكعك.</span></p>
<p><span dir="rtl">بل استمتع بالطعم الحلو، مع قراءة كُل حرف.</span></p>
<br/>
<p style="text-align:center; direction:ltr">When you drink coffee and you have a book between your hand, then you don’t need a cake, just enjoy the sweet taste with every letter.</p>
<br/>
<p><span dir="rtl">لماذا تعتقد بأن حياتك يجب أن تكون سعيدة دائماً؟</span></p>
<br/><p style="text-align:center">******</p>
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?75473420